import domready from 'domready';
import $ from 'jquery';
import '@fancyapps/fancybox';

import createHypernovaRenderer from './utils/createHypernovaRenderer';
import HypernovaComponents from './hypernova';
import loadFacebook from './lib/loadFacebook';

const FastClick = require('fastclick');

domready(() => {
    // Fastclick
    FastClick.attach(document.body);

    // Fancybox
    $.fancybox.defaults.btnTpl.downloadHigh = '<a download class="fancybox-button fancybox-download img"><span class="fa fa-download"></span></a>';
    $.fancybox.defaults.btnTpl.downloadPdf = '<a download class="fancybox-button fancybox-download pdf"><span class="fa fa-file-pdf-o"></span></a>';
    $.fancybox.defaults.buttons = [
        // 'downloadPdf',
        // 'downloadHigh',
        'fullScreen',
        'close',
    ];

    // Render elements
    const renderHypernova = createHypernovaRenderer(HypernovaComponents);
    const hypernovaElements = document.querySelectorAll('div[data-hypernova-key]');
    renderHypernova(hypernovaElements);

    loadFacebook();
});



// WEBPACK FOOTER //
// ./index.js